import { PageHead } from "../GtaxShell";
import { GtaxTraded } from "../GtaxTraded";

const PILLARS = [
  ["I", "Session structure", "Activity concentrates on the London and New York sessions, when gold's liquidity is deepest and price discovery is most reliable."],
  ["II", "Macro awareness", "Positioning is framed around the US dollar, real yields and scheduled macro events. Exposure is reduced into high-impact releases."],
  ["III", "Intraday execution", "Short-horizon, two-way trading. The desk can be long or short, and seeks to capture the day's range rather than forecast the year."],
  ["IV", "Risk first", "Position sizing is set relative to treasury equity, with a daily loss limit after which the desk stops trading for the day."],
];

const RISK = [
  ["Daily loss limit", "Trading halts for the day once the limit is reached"],
  ["Position sizing", "Calibrated to consolidated treasury equity, never to targets"],
  ["Event risk", "Exposure reduced ahead of tier-one macro releases"],
  ["Weekend risk", "Trading Monday to Friday only"],
];

export default function GtaxStrategy() {
  return (
    <div data-testid="gtax-strategy-page">
      <PageHead eyebrow="Our strategy" title="A disciplined, discretionary gold mandate."
        sub="One instrument, two sessions, four principles. The strategy aims to capture intraday opportunity in XAU/USD while keeping drawdowns contained."
        img="/gtax/chart.jpg" />
      <section className="py-24 gx-line">
        <div className="gx-wrap grid md:grid-cols-2 gap-6">
          {PILLARS.map(([n, h, p]) => (
            <div key={n} className="gx-card p-10 grid grid-cols-[56px_1fr] gap-6" data-testid={`gtax-pillar-${n}`}>
              <div className="gx-serif text-4xl gx-gold">{n}</div>
              <div><h3 className="gx-caps text-xl">{h}</h3><p className="mt-3 text-[color:var(--mute)] leading-relaxed">{p}</p></div>
            </div>
          ))}
        </div>
      </section>
      <GtaxTraded />
      <section className="py-24 gx-line gx-ivory">
        <div className="gx-wrap grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-6">
            <p className="gx-eyebrow">Risk governance</p>
            <h2 className="gx-serif text-4xl md:text-5xl mt-6">Capital preservation is the first trade.</h2>
            <dl className="mt-10 divide-y divide-[color:var(--line)] border-y border-[color:var(--line)]">
              {RISK.map(([k, v]) => (
                <div key={k} className="grid grid-cols-[180px_1fr] gap-6 py-5"><dt className="gx-caps text-sm">{k}</dt><dd className="text-[color:var(--mute)]">{v}</dd></div>
              ))}
            </dl>
          </div>
          <div className="lg:col-span-6 gx-photo h-[420px]"><img src="/gtax/coins.jpg" alt="Gold coins and balance scale" /></div>
        </div>
      </section>
    </div>
  );
}
